<ngx-loading [show]="isProcessing"></ngx-loading>


<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-header text-center">
        <h3 class="box-title">Emitir OS</h3>
        <br />
      </div>

      <div class="box-body" style="height: 700px;">
        <form novalidate [formGroup]="form">
          <div class="form-row">
            <div class="col-md-3" [hidden]="
                this.empreiteiras == null || this.empreiteiras.length == 1
              ">
              <div class="position-relative form-group">
                <label for="empreiteiraId">Empreiteira</label>
                <select class="form-control" formControlName="empreiteiraId" #empreiteiraId
                  (change)="getEncarregadosPorEmpreiteira(empreiteiraId.value)">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let e of empreiteiras" value="{{ e.id }}">
                    {{ e.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="encarregadoResponsavelId">Responsável OS</label>
                <select class="form-control" formControlName="encarregadoResponsavelId" (change)="changeParams()"
                  [ngClass]="{ 'h-error': validacaoEncarregado != '' }">
                  <option value="">selecione</option>
                  <option *ngFor="let e of encarregados" value="{{ e.id }}">
                    {{ e.nome }}
                  </option>
                </select>
                <span *ngIf="validacaoEncarregado != ''" class="text-danger">{{
                  this.validacaoEncarregado
                  }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="tipoProgramacao">Tipo de Programação</label>
                <select
                  class="form-control"
                  formControlName="tipoProgramacao"
                  (change)="changeParams()"
                >
                  <option value="1">Execução de serviço</option>
                  <option value="2">Avaliação de serviço</option>
                 
                </select>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small  *ngIf="form.get('tipoProgramacao').hasError('isNotValidTipoProgramacao')">
                    Selecione o Tipo de Programação
                  </small>
                </section>
              </div>
            </div>

            <div class="col-md-2" [hidden]="this.empreiteiras?.length == 1">
              <button type="button" class="btn btn-primary btn-block btn-bottom btn-shadow" (click)="buscar(true)"
                [disabled]="empreiteiraId?.value == ''">
                <i class="fa fa-search pull-left pt-1"></i>Buscar
              </button>
            </div>
          </div>
        </form>

        <section *ngIf="this.spvs?.length > 0" class="animated fadeInDown">
          <div class="box box-primary">
            <div class="box-header">
              <div class="row">
                <div class="col-md-6">
                  <div class="justify-content-start">
                    <h3 class="box-title">Resultado da Pesquisa</h3>
                    <br />
                    <span class="text-muted">Clique nas linhas que deseja selecionar</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex justify-content-end">
                    Selecionar:
                    <span class="cp pl-2 pr-2 text-primary" (click)="selecionarTodos()">Todos</span>/<span
                      class="cp pl-2 pr-1 text-primary" (click)="selecionarNenhum()">Nenhum</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="box-body">
              <div class="box-table" [ngClass]="{
                  h400: this.spvsComOS.length == 0,
                  h250: this.spvsComOS.length > 0
                }">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Tipo</th>
                      <th>Nº</th>
                      <th>Local</th>
                      <th>Área técnica</th>
                      <th>Serviço solicitado</th>
                      <th>Prioridade</th>
                      <th>Tipo de OS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let spv of this.spvs" [ngClass]="{ 'tr-info': spv.marcado }">
                      <td (click)="
                          getById(spv?.spvId, spv?.tipoSpv, modalDetalhesSpv)
                        " class="text-center cp" title="Visualizar detalhes">
                        <i class="fa fa-eye text-primary"></i>
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="text-center cp w60">
                        {{ spv?.tipoSpvStr }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="cp text-center">
                        {{ spv?.spvId | zerosEsquerda: 5 }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="cp">
                        {{ spv?.localDeTrabalho }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="cp">
                        {{ spv?.areaTecnica }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="cp">
                        {{ spv?.servicoSolicitado }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="text-center cp">
                        {{ spv?.prioridadeStr }}
                      </td>
                      <td (click)="selecionarSpv(spv?.spvId)" class="text-center cp">
                        {{ spv?.tipoOSStr }}
                      </td>
                    </tr>
                    <tr *ngFor="let v of this.voids">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <section *ngIf="this.spvsComOS.length > 0" class="mt-2">
                <div class="box-table" style="height: 150px">
                  <div class="tarja-aviso">
                    <p><b><i class="fa fa-warning pr-2"></i>Atenção: </b> os itens que você selecionou e que estão
                      assinalados abaixo já geraram OSs por outro usuário</p>
                  </div>

                  <table>
                    <tbody>
                      <tr *ngFor="let spv of this.spvsComOS" class="tarja-aviso">
                        <td class="text-center cp" title="Reimprimir OS Nº {{ spv?.osId | zerosEsquerda : 5 }}">
                          <button type="button" class="btn btn-sm" (click)="reimprimirOS(spv?.osId, spv?.tipoOSFilha)">
                            <i class="fa fa-print text-primary" *ngIf="imprimindoOSId != spv?.osId"></i>
                            <i *ngIf="imprimindoOS && imprimindoOSId == spv?.osId"
                              class="fa fa-spinner fa-spin fa-fw"></i>
                          </button>
                        </td>

                        <td (click)="
                            getById(spv?.spvId, spv?.tipoSpv, modalDetalhesSpv)
                          " class="text-center cp" title="Visualizar detalhes">
                          <i class="fa fa-eye text-primary"></i>
                        </td>

                        <td class="text-center cp w60">
                          {{ spv?.tipoSpvStr }}
                        </td>
                        <td class="cp text-center">
                          {{ spv?.spvId | zerosEsquerda: 5 }}
                        </td>
                        <td class="cp">{{ spv?.localDeTrabalho }}</td>
                        <td class="cp">{{ spv?.areaTecnica }}</td>
                        <td class="cp">{{ spv?.servicoSolicitado }}</td>
                        <td class="text-center cp">{{ spv?.prioridadeStr }}</td>
                        <td class="text-center cp">{{ spv?.tipoOSStr }}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
                <div class="row mt-1 mb-1">
                  <div class="offset-md-10 col-md-2">
                    <button type="button" class="btn btn-block btn-warning" (click)="clearSpvsComOS()">
                      Fechar aviso
                    </button>
                  </div>
                </div>
              </section>
            </div>

            <div class="box-footer">
              <span *ngIf="this.spvs !== undefined && this.spvs?.length > 0" class="pl-2 pt-1 pb-2">Total pesquisados :
                <b>{{ this.spvs?.length }}</b></span>
            </div>
          </div>
        </section>

        <ng-template #modalDetalhesSpv let-c="close" let-d="dismiss">
          <div class="modal-header">
            <h4 *ngIf="spvCompleto?.spvAprovadoId != null" class="modal-title">
              Detalhes SS Nº
              <b><span>{{ spvCompleto?.spvId | zerosEsquerda: 5 }}</span></b>
            </h4>
            <h4 *ngIf="spvCompleto?.ptId != null" class="modal-title">
              Detalhes PT Nº
              <b><span>{{ spvCompleto?.spvId | zerosEsquerda: 5 }}</span></b>
            </h4>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="bx-tb-detalhes pre-scrollable">
                  <table class="table table-bordered tb-detalhes">
                    <tbody>
                      <tr>
                        <th colspan="4" class="text-center title">Cadastro</th>
                      </tr>

                      <tr>
                        <th>Data Hora do Cadastro</th>
                        <td>
                          {{
                          spvCompleto?.dataHoraCadastro
                          | date: "dd/MM/yyyy HH:mm"
                          }}
                        </td>
                        <th>Usuário Solicitante</th>
                        <td>{{ spvCompleto?.usuarioSolicitante }}</td>
                      </tr>
                      <tr>
                        <th>Requisitante</th>
                        <td>{{ spvCompleto?.requisitante }}</td>
                        <th>Ramal</th>
                        <td>{{ spvCompleto?.contato }}</td>
                      </tr>
                      <tr>
                        <th>Servico</th>
                        <td colspan="3">{{ spvCompleto?.servico }}</td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <th>Status Atual</th>
                        <td>{{ spvCompleto?.statusStr }}</td>
                        <th>Data Status</th>
                        <td>
                          {{ spvCompleto?.dataStatus | date: "dd/MM/yyyy" }}
                        </td>
                      </tr>
                      <tr>
                        <th>{{labelCentroCusto}}</th>
                        <td colspan="4">{{ spvCompleto?.centroCusto }}</td>
                      </tr>

                      <tr *ngIf="spvCompleto?.spvAprovadoId != null">
                        <th colspan="4" class="text-center title">
                          Aprovação/Qualificação
                        </th>
                      </tr>
                      <tr *ngIf="spvCompleto?.spvAprovadoId != null">
                        <th>Data Aprovação</th>
                        <td>
                          {{
                          spvCompleto?.dataHoraAprovacao | date: "dd/MM/yyyy"
                          }}
                        </td>
                        <th>Aprovado por</th>
                        <td>{{ spvCompleto?.aprovadoPor }}</td>
                      </tr>
                      <tr *ngIf="spvCompleto?.spvAprovadoId != null">
                        <th>Qualificado por</th>
                        <td>{{ spvCompleto?.qualificadoPor }}</td>
                        <th>Prioridade</th>
                        <td>{{ spvCompleto?.prioridadeStr }}</td>
                      </tr>
                      <tr *ngIf="spvCompleto?.ptId != null">
                        <th>Data Aprovação</th>
                        <td>
                          {{
                          spvCompleto?.dataHoraAprovacao | date: "dd/MM/yyyy"
                          }}
                        </td>
                        <th>Prioridade</th>
                        <td>{{ spvCompleto?.prioridadeStr }}</td>
                      </tr>
                      <tr>
                        <th>Observações Gerais</th>
                        <td colspan="3">
                          {{ spvCompleto?.observacoesGerais }}
                        </td>
                      </tr>
                      <tr>
                        <th>Área restrita</th>
                        <td>{{ spvCompleto?.areaRestritaStr }}</td>
                        <th>Fim de Semana</th>
                        <td>{{ spvCompleto?.fimDeSemanaStr }}</td>
                      </tr>
                      <tr>
                        <th>Engenheiro Responsável</th>
                        <td>
                          {{
                          spvCompleto?.engenheiroResponsavel == ""
                          ? " - "
                          : spvCompleto?.engenheiroResponsavel
                          }}
                        </td>
                        <th>Responsável OS</th>
                        <td>
                          {{
                          spvCompleto?.encarregadoResponsavel == null
                          ? " - "
                          : spvCompleto?.encarregadoResponsavel
                          }}
                        </td>
                      </tr>
                      <tr>
                        <th>Área Técnica</th>
                        <td>{{ spvCompleto?.areaTecnica }}</td>
                        <th>Prédio</th>
                        <td>{{ spvCompleto?.predio }}</td>
                      </tr>
                      <tr>
                        <th>Equipamento</th>
                        <td>{{ spvCompleto?.equipamento }}</td>
                        <th>Empreiteira</th>
                        <td>{{ spvCompleto?.empreiteira }}</td>
                      </tr>
                      <tr>
                        <th colspan="4" class="text-center title">
                          Colaboradores
                        </th>
                      </tr>

                      <tr *ngFor="let c of spvCompleto?.colaboradores">
                        <td colspan="2" class="text-center">{{ c?.nome }}</td>
                        <td colspan="2" class="text-center">
                          {{ c?.matricula }}
                        </td>
                      </tr>
                      <tr *ngIf="spvCompleto?.colaboradores.length == 0">
                        <th colspan="4" class="text-center">Não informado</th>
                      </tr>

                      <tr>
                        <th colspan="4" class="text-center title">
                          Check Lists
                        </th>
                      </tr>
                      <tr *ngFor="let tcl of spvCompleto?.tipoCheckLists">
                        <td colspan="4">
                          <ul class="list-group">
                            <li class="tipocl list-group-item">
                              {{ tcl?.descricao }}
                            </li>
                            <li class="list-group-item">
                              <ul class="list-group">
                                <li *ngFor="let cl of tcl.checksLists" class="list-group-item">
                                  {{ cl?.item }}
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr *ngIf="spvCompleto?.tipoCheckLists.length == 0">
                        <th colspan="4" class="text-center">Não informado</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary pl-5 pr-5 mr-3" (click)="c('Close click')">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-md-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-2">
            <app-ball-pulse *ngIf="this.isSalvando"></app-ball-pulse>
          </div>
          <div class="col-md-2 text-right pr-3 mt-2">
            <div class="custom-checkbox custom-control">
              <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px" [checked]="false"
                #imprimirEvidenciaDeFotos />
              <label class="form-check-label" for="">
                Imprime a evidência de fotos?
              </label>
            </div>
          </div>
          <div class="col-md-2 text-right pr-3 mt-2">
            <div class="custom-checkbox custom-control">
              <input class="form-check-input cp" type="checkbox" style="height: 15px; width: 15px" checked
                #obterosmanual />
              <label class="form-check-label" for=""> Obter OS Manual </label>
            </div>
          </div>
          <div class="col-md-2">
            <div class="d-flex justify-content-end">
              <button class="btn btn-lg btn-primary btn-shadow btn-block" type="button" (click)="submit()" [disabled]="
                  this.totalSpvsSelecionados == 0 ||
                  this.isSalvando ||
                  !this.autorizacoes?.podeIncluir
                ">
                <i class="fa fa fa-print pt-1 pull-left"></i>Gerar OS
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>